import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

const faqData = [
  {
    question: "What is Million2Trillion?",
    answer:
      "Million2Trillion is a verified global platform that connects all financial market professionals — including traders, investors, brokers, educators, coders, institutions, and anyone involved in financial markets — into a unified, trust-first ecosystem.",
  },
  {
    question: "How does it work?",
    answer:
      "Once verified, you receive a SmartCard that unlocks your role-based dashboard, marketplace tools, monetization layers, and more — all inside a secure virtual office.",
  },
  {
    question: "Why is it different from other platforms?",
    answer:
      "Unlike social platforms or SaaS tools, M2T is fully role-based, monetization-enabled, and trust-verified — making it a true infrastructure for financial market professionals.",
  },
  {
    question: "Who can join the platform?",
    answer:
      "Anyone involved in the financial market ecosystem — including traders, educators, investors, legal advisors, fintech builders, and startups — can join and create a verified SmartCard profile.",
  },
  {
    question: "Is it just another trading platform?",
    answer:
      "M2T is not just a trading platform. It is a global financial market ecosystem — where you can run your business, grow your reach, and collaborate securely with others.",
  },
  {
    question: "Can I earn from day one?",
    answer:
      "Yes. Once verified, you can start offering services, share your content, apply for jobs, and promote your SmartCard — turning your identity into income.",
  },
  {
    question: "What will Million2Trillion provide?",
    answer:
      "SmartCard login, Role based dashboard, monetization tools, a verified directory, AI tools, service marketplace, launch pad, funding access, legal advisory, and more.",
  },
  {
    question: "How can I join as a business partner?",
    answer:
      "You can onboard as a verified role — or partner with us via licensing, SaaS integrations, or regional expansion roles. Reach out through our contact page.",
  },
  {
    question: "What is the strength of this platform?",
    answer:
      "Every user on Million2Trillion is real, verified, and role-specific. The platform is secured and designed for infinite growth, instant monetization, verified communication, and borderless trust.",
  },

  {
    question: "Why should I use Million2Trillion?",
    answer:
      "Because it’s a verified system built for serious financial professionals. It gives you tools, visibility, monetization, and global trust.",
  },
  {
    question: "How does the directory help us?",
    answer:
      "The directory helps others find you based on your role. You become visible globally to clients, partners, and service seekers.",
  },

  {
    question: "How does this platform promote my business?",
    answer:
      "We auto-promote your verified role, content, and SmartCard to other users inside your category — and even outside via affiliate layers.",
  },
  {
    question: "Do I need to spend more money on ads?",
    answer:
      "No. The platform itself promotes you. Every verified user is a promoter — that’s the beauty of the circular growth system.",
  },
  {
    question: "How does AI assistance work for me?",
    answer:
      "Our AI tools help write content, create offers, auto-respond to inquiries, and assist in matching with clients or partners.",
  },
  {
    question: "Will I get global exposure?",
    answer:
      "Yes. Your SmartCard, offers, and posts are discoverable across 100+ countries. Verified users get search visibility.",
  },
];

export default function FaqPreviewSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
      id="FaqPreview"
      style={{ paddingTop: "100px" }}
      className="bg-[#0B0F19] px-4 py-12 text-white"
    >
      <div className="mx-auto max-w-6xl">
        <h2 className="mb-10 text-center text-3xl font-bold italic">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-lg border border-gray-700 p-4 transition duration-200 hover:bg-black"
              onClick={() => toggle(index)}
            >
              <div className="flex cursor-pointer items-center justify-between">
                <span className="font-semibold">
                  {index + 1}. {item.question}
                </span>
                {openIndex === index ? (
                  <ChevronDown className="h-5 w-5" />
                ) : (
                  <ChevronRight className="h-5 w-5" />
                )}
              </div>
              {openIndex === index && (
                <p className="mt-2 text-gray-900">{item.answer}</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="/faq"
            className="inline-block font-medium text-yellow-400 hover:underline"
          >
            View All Questions →
          </a>
        </div>
        {/*
        <div className="mt-16 bg-gray-800 rounded-xl py-8 px-6 text-center">
          <h3 className="text-2xl font-bold mb-2">Start building with Million2Trillion</h3>
          <p className="text-gray-400 mb-4">Your verified role. Your SmartCard. Your monetized future.</p>
          <a
            href="/signup"
            className="inline-block bg-yellow-400 text-black font-semibold px-6 py-2 rounded hover:bg-yellow-300 transition"
          >
          Get Started
          </a>
        </div>
        */}
      </div>
    </section>
  );
}
